import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=56671233&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&id=56671233&prod&lang=scss&scoped=true&"
import style1 from "./chat.vue?vue&type=style&index=1&id=56671233&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56671233",
  null
  
)

export default component.exports